import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {TabManagementService} from "@core-services/tab-management.service";
import {PageEventInterface} from "@core/interfaces/page-event.interface";
import {PageOffering} from "@core/model/side-nav.model";
import {LeaseSummary, RentalPricingOption} from "@features/leasing/leasing.model";
import {LeasingService} from "@features/leasing/leasing.service";
import {LeaseBookingsComponent} from "@features/leasing/lease-bookings/lease-bookings.component";
import {GenericDatasource} from "@shared-datasource/generic.datasource";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {PaginatorService} from "@shared-services/paginator.service";
import {UtilsService} from "@shared-services/utils.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {tap} from "rxjs";

@Component({
  selector: 'app-retailer-leasing-history',
  templateUrl: './retailer-leasing-history.component.html',
})
export class RetailerLeasingHistoryComponent implements OnInit, AfterViewInit{
  @Input() id!: string;
  @Input() companyName!: string;
  @Input() tenantType!: string;
  @Input() offering!: PageOffering;
  @ViewChild('paginator') paginator!: MatPaginator;

  displayedColumns: string[] = ['id', 'companyName', 'startDate', 'endDate', 'spaceName', 'size', 'rentalType', 'monthlyRentalFee', 'leaseStatus'];
  dataSource = new GenericDatasource<LeaseSummary>(this.leasingService);

  constructor(public utils: UtilsService,
              public dateUtils: DateUtilsService,
              private paginatorService: PaginatorService,
              private leasingService: LeasingService,
              private tabService: TabManagementService,
              public loader: LoadingService) {
  }

  ngOnInit() {
    this.dataSource = new GenericDatasource<LeaseSummary>(this.leasingService);
    this.dataSource.loadData('/current-leases', { size: '5', page: '0', sort: 'leaseStartDate,desc'}, [{ name: 'retailerId', val: this.id }]);
  }

  ngAfterViewInit() {
    this.paginator._intl.getRangeLabel = this.paginatorService.getRangeDisplayText;
    this.paginator.page
      .pipe(
        tap(() => this.loadLeases()))
      .subscribe();
  }

  loadLeases() {
    const page = {size: this.paginator.pageSize.toString(), page: this.paginator.pageIndex.toString(), sort: 'leaseStartDate,desc'};
    this.dataSource.loadData('/current-leases', page, [{ name: 'retailerId', val: this.id }]);
  }

  getLeaseStatus(lease: LeaseSummary) {
    switch (lease.leaseStatus) {
      case 'APPROVED':
        return { status: this.utils.displayStatus('APPROVED'), icon: 'check_circle', outline: true, className: 'success-chip'};
      case 'ACTIVE':
        return { status: this.utils.displayStatus('ACTIVE'), icon: 'check_circle', outline: false, className: 'success-chip'};
      case 'EXPIRED':
        return { status: this.utils.displayStatus('EXPIRED'), icon: 'check_circle', outline: false, className: 'disabled-chip'};
      case 'TERMINATED':
        return { status: this.utils.displayStatus('TERMINATED'), icon: 'cancel', outline: false, className: 'disabled-chip'};
      default:
        return { status: this.utils.displayStatus('PLANNED'), icon: 'check_circle', outline: true, className: 'warn-chip'};
    }
  }

  openCreateLeaseTab() {
    let payload: PageEventInterface = {
      componentToRegister: LeaseBookingsComponent,
      pageName: 'Create a lease',
      pageHeader: this.offering.label,
      data: { retailerId: this.id },
      id: this.utils.generateUuidWithPrefix('lease-bookings'),
      offeringId: this.offering.offeringUuid,
      sectionCode: 'leasing',
      pageCode: 'lease-bookings',
      offering: this.offering
    }
    this.tabService.sendPageAddEvent(payload);
  }

  getRentalType(code: RentalPricingOption, lease: LeaseSummary) {
    return this.leasingService.getRentalType(code, lease.baseBookingConfig ?? null);
  }

}
